import { fromPairs, isNil } from "lodash";
import { Component, EventEmitter, OnInit, Output, forwardRef, input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TranslateService } from "@root/shared/service/translate.service";

interface Item {
  key: GuestField;
  i18nKey: string;
  value: number;
  min: number;
}

type GuestField = "adults" | "children" | "infants" | "pets";

export const V4_GUEST_SELECT_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => V4GuestSelectComponent),
  multi: true,
};

@Component({
  selector: "v4-guest-select",
  templateUrl: "./guest-select.component.html",
  styleUrls: ["./guest-select.component.scss"],
  providers: [V4_GUEST_SELECT_ACCESSOR],
})
export class V4GuestSelectComponent implements OnInit, ControlValueAccessor {
  @Output() visibleChange = new EventEmitter<boolean>();
  size = input<"default" | "small" | "large">("default");
  listOfItem: Item[] = [
    { key: "adults", i18nKey: "guest-select_html_adults", value: 1, min: 1 },
    { key: "children", i18nKey: "guest-select_html_children", value: 0, min: 0 },
    { key: "infants", i18nKey: "guest-select_html_infants", value: 0, min: 0 },
    { key: "pets", i18nKey: "guest-select_html_pets", value: 0, min: 0 },
  ];

  textItem;

  _registerOnChange: (value: Record<string, string>) => void = (_: any) => {};

  constructor(private t: TranslateService) {}

  ngOnInit() {
    this.updateTextItem();
  }

  private updateTextItem() {
    const rst = this.listOfItem
      .filter((item) => item.value > 0)
      .map((item) => this.t.t(`${item.i18nKey}_${item.value > 1 ? "p" : "s"}`, { number: item.value }));
    // this.listOfItem.forEach((item) => {
    //   if (item.value > 0) {
    //     rst.push(this.t.t(`${item.key}_${item.value > 1 ? "p" : "s"}`, { number: item.value }));
    //   }
    // });
    this.textItem = rst.join(", ");
  }

  private emitValue() {
    const pairs = this.listOfItem.map((item) => [item.key, item.value]);
    this._registerOnChange(fromPairs(pairs));
  }

  onChangeValue(item: Item, operate: "-" | "+") {
    if (operate === "-") {
      if (item.value <= item.min) {
        return;
      }
      item.value = item.value - 1;
    } else {
      item.value = item.value + 1;
    }
    this.updateTextItem();
    this.emitValue();
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: Record<GuestField, number>): void {
    this.listOfItem.forEach((item) => {
      if (!isNil(value[item.key])) {
        item.value = value[item.key];
      }
    });
    this.updateTextItem();
    // this.value = value;
  }
}
